import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const AddRateDrawer = ({ isOpen, onClose, onAddRate }) => {
  const [formData, setFormData] = useState({
    rate_per_km: "",
    weight_divisor: "",
    minimum_fee: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value })); 
  };

  const handleSubmit = () => {
    onAddRate({
      rate_per_km: parseFloat(formData.rate_per_km || "0"),
      weight_divisor: parseFloat(formData.weight_divisor || "0"),
      minimum_fee: parseFloat(formData.minimum_fee || "0"),
    });
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Add Kilometer Rate</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Rate per KM"
            name="rate_per_km"
            value={formData.rate_per_km}
            onChange={handleChange}
            placeholder="Rate per kilometer"
            type="number"
            step="0.01"
          />

          <ReusableInput
            label="Weight Divisor"
            name="weight_divisor"
            value={formData.weight_divisor}
            onChange={handleChange}
            placeholder="e.g. 10.0"
            type="number"
            step="0.01"
          />

          <ReusableInput
            label="Minimum Delivery Fee"
            name="minimum_fee"
            value={formData.minimum_fee}
            onChange={handleChange}
            placeholder="e.g. 30.00"
            type="number"
            step="0.01"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddRateDrawer;
